import React, { useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import { Box, Paper, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";

// styling functions for SearchBar
const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
        width: "auto",
    },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    width: "100%",
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        [theme.breakpoints.up("md")]: {
            //width: "60",
        },
    },
}));

type SearchBarProps = {
    value: string;
    onValueChange: (value: string) => void;
    onSearch: (value: string) => void;
};

const searchTips = [
    "JavaScript",
    "React",
    "Python",
    "Java",
    "Kobe",
    "Lebron",
    "NUS",
    "calculus",
    "superman",
    "calcium dioxide",
    "nuclear",
    "quantum mechanics",
    "organic chemistry",
    "walao idealogy",
];

const SearchBar: React.FC<SearchBarProps> = ({ value, onValueChange, onSearch }) => {
    const [showTips, setShowTips] = useState(false);
    function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            if (value) {
                onSearch(value);
                setShowTips(false);
            }
        }
    }

    function handleTipClick(tip: string) {
        onValueChange(tip);
        onSearch(tip);
        setShowTips(false);
    }

    return (
        <Box sx={{ position: "relative", width: "100%" }}>
            <Search sx={{ flexGrow: 1 }}>
                <SearchIconWrapper>
                    <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                    id="search"
                    placeholder={"[tag] To search within a tag"}
                    value={value}
                    onChange={(e) => {
                        onValueChange(e.target.value);
                        setShowTips(true);
                    }}
                    inputProps={{ "aria-label": "search" }}
                    onKeyDown={handleKeyPress}
                    autoComplete="off"
                />
            </Search>
            {showTips && value && (
                <Paper sx={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 1 }}>
                    {searchTips
                        .filter((tip) => tip.toLowerCase().includes(value.toLowerCase()))
                        .map((tip) => (
                            <Typography
                                key={tip}
                                onClick={() => handleTipClick(tip)}
                                sx={{ padding: 1, cursor: "pointer" }}
                            >
                                {tip}
                            </Typography>
                        ))}
                </Paper>
            )}
        </Box>
    );
};

export default SearchBar;
